import React from 'react';
import PropTypes from 'prop-types';
import { getSmoothStepPath, getEdgeCenter } from 'react-flow-renderer';

import './index.css';

const foreignObjectSize = 40;

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  label,
}) {
  const edgePath = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const handleRemoveButtonClick = () => data.onRemove(id);

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={targetY - sourceY > 0 ? markerEnd : ''}
      />
      <foreignObject
        width={foreignObjectSize}
        height={foreignObjectSize}
        x={edgeCenterX - foreignObjectSize / 2}
        y={edgeCenterY - foreignObjectSize / 2}
        className="edgebutton-foreignobject"
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <div>
          <button
            type="button"
            className="edgebutton"
            onClick={handleRemoveButtonClick}
          >
            ×
          </button>
          {label && (
            <small className="condition-node-edge-label">{label}</small>
          )}
        </div>
      </foreignObject>
    </>
  );
}

CustomEdge.defaultProps = {
  style: {},
  label: null,
};

CustomEdge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  targetX: PropTypes.number.isRequired,
  targetY: PropTypes.number.isRequired,
  sourcePosition: PropTypes.string.isRequired,
  targetPosition: PropTypes.string.isRequired,
  style: PropTypes.object,
  markerEnd: PropTypes.string.isRequired,
  data: PropTypes.shape({
    onRemove: PropTypes.func.isRequired,
  }).isRequired,
  label: PropTypes.string,
};
